import * as React from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Typography from "@mui/material/Typography";
import { Container, Row, Col } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";

export default function VerticalLinearStepper() {
  React.useEffect(() => {
    AOS.init();
  }, []);
  return (
    <Container>
      <Row className="justify-content-center align-items-end">
        <Col md={6} xs={12} data-aos="fade-down">
          <Typography
            className="py-3"
            fontWeight={600}
            variant="h5"
            gutterBottom
          >
            Course Responsibilities
          </Typography>
          <Stepper orientation="vertical">
            {steps.map((step, index) => (
              <Step key={index} active={true}>
                <StepLabel>{step.label}</StepLabel>
                <StepContent>
                  <Typography>{step.description}</Typography>
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </Col>
        <Col md={6} xs={12} data-aos="fade-up">
          <Typography
            className="py-3"
            fontWeight={600}
            variant="h5"
            gutterBottom
          >
            Requirements for Enrolling
          </Typography>
          <Stepper orientation="vertical">
            {Requirements.map((step, index) => (
              <Step key={index} active={true}>
                <StepLabel>{step.label}</StepLabel>
                <StepContent>
                  <Typography>{step.description}</Typography>
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </Col>
      </Row>
    </Container>
  );
}

const steps = [
  {
    label: "Regular responsive and attentive presence in the classes.",
    description: ``,
  },
  {
    label: "Completion of assignment assigned by the honorable teachers.",
    description: "",
  },
  {
    label:
      "A student under a PRTP batch can voluntarily assist an honorable PRTP teacher if an honorable PRTP teacher wishes to take assistance.",
    description: ``,
  },
];

const Requirements = [
  {
    label: "Undergraduate, graduate, and post graduate students",
    description: ``,
  },
  {
    label:
      "Students (both existing and passed) from all backgrounds(subjects)are invited to join in PRTP",
    description: "",
  },
];
